import { useQuery } from '@tanstack/react-query'

import {
  getAIProductPhotosList,
  type GetAIProductPhotosListOptions,
} from '@flecto/api/shared'

export type UseQueryGetAIProductPhotosListOptions = GetAIProductPhotosListOptions & {
  title?: string
  enabled?: boolean
}

export function useQueryGetAIItemPhotosList({
  title,
  enabled = true,
  ...options
}: UseQueryGetAIProductPhotosListOptions) {
  return useQuery({
    queryKey: ['QueryGetAIItemPhotosList', title],
    queryFn: async () =>
      await getAIProductPhotosList({ title: title ?? '' }, options),
    refetchOnWindowFocus: false,
    enabled,
  })
}
